class MobileNav extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('[data-mobile-nav-toggle]');
    this.drawer = this.querySelector('[data-mobile-nav-drawer]');
    this.closeBtn = this.querySelector('[data-mobile-nav-close]');

    if (!this.toggle || !this.drawer) return;

    this.toggle.addEventListener('click', this.open);
    this.closeBtn?.addEventListener('click', this.close);
    this.drawer.addEventListener('click', this.onDrawerClick);
    this.drawer.addEventListener('close', this.onClosed);
  }

  disconnectedCallback() {
    this.toggle?.removeEventListener('click', this.open);
    this.closeBtn?.removeEventListener('click', this.close);
    this.drawer?.removeEventListener('click', this.onDrawerClick);
    this.drawer?.removeEventListener('close', this.onClosed);
  }

  open = () => {
    if (!this.drawer || this.drawer.open) return;
    this.drawer.showModal();
    this.toggle.setAttribute('aria-expanded', 'true');
  };

  close = () => {
    if (!this.drawer?.open) return;
    this.drawer.close();
  };

  onClosed = () => {
    this.toggle.setAttribute('aria-expanded', 'false');
  };

  onDrawerClick = (event) => {
    if (event.target === this.drawer) this.close();
  };
}

customElements.define('mobile-nav', MobileNav);
